module.exports = {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 25.91 25.969",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }